import { render, staticRenderFns } from "./SendNotifications.vue?vue&type=template&id=5d9e4b63"
import script from "./SendNotifications.vue?vue&type=script&lang=js"
export * from "./SendNotifications.vue?vue&type=script&lang=js"
import style0 from "./SendNotifications.vue?vue&type=style&index=0&id=5d9e4b63&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports